// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://api.rocketlane.com/api/1.0', // Official API with better pagination
  BASE_URL_V1: 'https://api.rocketlane.com/api/v1', // Fallback for some endpoints
  AUTH_METHOD: 'api-key', // Use 'api-key' header instead of Bearer token
  TIMEOUT: 60000, // 60 seconds (increased for pagination)
  PAGINATION_TIMEOUT: 120000, // 2 minutes for pagination requests
  RETRY_ATTEMPTS: 3,
  REFRESH_INTERVAL: 5 * 60 * 1000, // 5 minutes
  
  // Enhanced rate limiting configuration
  RATE_LIMITS: {
    REQUESTS_PER_MINUTE: 400, // RocketLane's limit
    GET_REQUESTS_PER_MINUTE: 60, // For "Get all" endpoints
    RETRY_DELAY: 5000, // 5 seconds default retry delay
  },
  
  // Pagination configuration
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 50,
    MAX_PAGE_SIZE: 100, // RocketLane's maximum
    MAX_TOTAL_ITEMS: 1000, // Safety limit for getAllPages
  },
  
  // Field selection defaults (corrected field names from Swagger spec)
  DEFAULT_FIELDS: {
    PROJECTS: ['projectId', 'projectName', 'status', 'startDate', 'dueDate', 'owner', 'companyId', 'companyName'],
    TASKS: ['taskId', 'taskName', 'status', 'assignees', 'dueDate', 'effort', 'atRisk', 'type', 'project', 'phase'],
    USERS: ['userId', 'firstName', 'lastName', 'name', 'email', 'role', 'status'],
    TIME_ENTRIES: ['timeEntryId', 'date', 'minutes', 'description', 'user', 'task', 'project', 'activityName'],
    ALLOCATIONS: ['allocationId', 'user', 'project', 'taskId', 'startDate', 'endDate', 'allocationMinutes'],
    FIELDS: ['fieldId', 'fieldLabel', 'objectType', 'fieldType', 'active'],
    PHASES: ['phaseId', 'phaseName', 'startDate', 'dueDate', 'status', 'projectId'],
    TIME_OFFS: ['timeOffId', 'user', 'startDate', 'endDate', 'type', 'durationInMinutes'],
    SPACES: ['spaceId', 'name', 'description'],
    SPACE_DOCUMENTS: ['id', 'spaceId', 'name', 'contentType', 'size', 'createdAt', 'createdBy'],
    COMPANIES: ['companyId', 'name', 'domain', 'status'],
    INVOICES: ['invoiceId', 'invoiceNumber', 'status', 'currency', 'amount', 'issuedDate', 'dueDate'],
    RATE_CARDS: ['rateCardId', 'name', 'currencyCode', 'active'],
  },
  
  // Cache configuration
  CACHE: {
    DURATION: 5 * 60 * 1000, // 5 minutes
    ENABLED: true,
  },
};

// Environment-specific API keys
export const API_KEYS = {
  PROD: 'rl-2dcbce94-b80c-4154-8f96-1289e8dc85cf',
  SANDBOX: 'rl-5ea24e2f-b451-41ea-a232-b2429c74d045'
};

// Default environment
export const DEFAULT_ENVIRONMENT = 'PROD';

// Dashboard Configuration
export const DASHBOARD_CONFIG = {
  METRICS: {
    UTILIZATION_TARGET: 80,
    SUCCESS_RATE_TARGET: 90,
    TIME_TO_VALUE_TARGET: 30, // days
    DEFAULT_WORK_WEEK_HOURS: 40, // Default work week capacity in hours
  },
  REFRESH: {
    AUTO_REFRESH: true,
    INTERVAL: 5 * 60 * 1000, // 5 minutes
  },
  DISPLAY: {
    MAX_PROJECTS: 10,
    MAX_TASKS: 10,
    CHART_HEIGHT: 300,
  }
};

// Status mappings for Rocketlane data
export const STATUS_MAPPINGS = {
  PROJECT: {
    'active': 'on-track',
    'completed': 'completed',
    'archived': 'completed',
    'on-hold': 'at-risk',
    'cancelled': 'overdue',
  },
  TASK: {
    'in-progress': 'on-track',
    'completed': 'completed',
    'blocked': 'at-risk',
    'overdue': 'overdue',
  }
};

// Error messages
export const ERROR_MESSAGES = {
  API_UNAVAILABLE: 'Unable to connect to Rocketlane API. Please check your connection and try again.',
  AUTHENTICATION_FAILED: 'Authentication failed. Please check your API credentials.',
  RATE_LIMIT_EXCEEDED: 'API rate limit exceeded. Please try again later.',
  INVALID_DATA: 'Invalid data received from API. Please contact support.',
  NETWORK_ERROR: 'Network error occurred. Please check your internet connection.',
  PAGINATION_LIMIT: 'Maximum data limit reached. Consider using filters to narrow your search.',
  FIELD_SELECTION_ERROR: 'Invalid field selection. Please check your includeFields parameter.',
  FILTER_ERROR: 'Invalid filter format. Please use the correct operator syntax.',
};

// Filter operators supported by RocketLane API
export const FILTER_OPERATORS = {
  EQUAL: 'eq',
  GREATER_THAN: 'gt',
  LESS_THAN: 'lt',
  GREATER_EQUAL: 'ge',
  LESS_EQUAL: 'le',
  CONTAINS: 'cn',
  NOT_CONTAINS: 'nc',
};

// Common filter presets
export const FILTER_PRESETS = {
  ACTIVE_PROJECTS: { status: { operator: FILTER_OPERATORS.EQUAL, value: 'active' } },
  OVERDUE_TASKS: { 
    dueDate: { operator: FILTER_OPERATORS.LESS_THAN, value: new Date().toISOString().split('T')[0] },
    status: { operator: FILTER_OPERATORS.NOT_CONTAINS, value: 'completed' }
  },
  RECENT_TIME_ENTRIES: { 
    date: { operator: FILTER_OPERATORS.GREATER_EQUAL, value: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0] }
  },
};
